var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "config-group small-12 medium-12 column d-flex flex-column align-items-center",
    },
    [
      _c(
        "div",
        { staticClass: "config-item w-100 my-auto position-relative" },
        [
          _c(
            "div",
            { staticClass: "config-item__info d-inline-flex" },
            [
              _c("label", { attrs: { for: _vm.option.id } }, [
                _vm._v(_vm._s(_vm.option.name)),
              ]),
              _vm._v(" "),
              _vm.tooltip
                ? _c("Tooltip", { attrs: { infoText: _vm.tooltip } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex gap-4 justify-space-between align-items-end",
            },
            [
              _c("InputStepper", {
                attrs: {
                  min: _vm.option.customValues.minAnzahlSorten ?? 1,
                  max: _vm.option.customValues.maxAnzahlSorten,
                  value: _vm.option.dynamicValues.numSorten,
                },
                on: { change: _vm.changeSortenAmount },
              }),
              _vm._v(" "),
              _vm.option.dynamicValues.numSorten > 1
                ? _c(
                    "button",
                    { staticClass: "btn btn--dark", on: { click: _vm.open } },
                    [
                      _vm._v(
                        _vm._s(_vm._f("translate")("textSortenverteilung"))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.message
            ? _c(
                "div",
                {
                  staticClass:
                    "text-small mt-prj text-error d-flex line-height-12 option-auflage-error",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "mr-2 svg-icon flex-child-fix position-relative t-1px",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#e94d47" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n      " + _vm._s(_vm.message) + "\n    "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("SortenVerteilungModal", {
            ref: "sortenVerteilungModalRef",
            attrs: { option: _vm.option },
            on: { saved: _vm.sortenInputModalSaved },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }